import { useColorMode } from '@chakra-ui/react';

import { Xmark } from '@peacecover/icon';
import { useHandleHistoryBack } from '@pocapan/shared/utils/useHandleHistoryBack';
import { useTradeReviewPageQuery } from './hooks/useTradeReviewPageQuery';
import TradeCompleteRequest from './components/TradeCompleteRequest';
import PostReviewRequest from './components/PostReviewRequest';

const TradeReviewRequestPage = () => {
  const { colorMode } = useColorMode();
  const handleHistoryBack = useHandleHistoryBack();

  const { mode, data, isLoading } = useTradeReviewPageQuery();

  return (
    <div
      className="min-h-screen pt-[calc(env(safe-area-inset-top))] pb-[calc(env(safe-area-inset-bottom))] bg-repeat"
      style={{
        backgroundImage: `url('/assets/backgrounds/bg_request_review_${colorMode === 'dark' ? 'dark' : 'light'}.png')`,
        backgroundRepeat: 'round'
      }}
    >
      <div className="flex items-center px-[16px] py-[8px]">
        <button type="button" className="my-[2px]" onClick={handleHistoryBack}>
          <Xmark />
        </button>
      </div>
      {isLoading ? null : mode === 'review' ? (
        <PostReviewRequest reviewData={data.review} />
      ) : (
        <TradeCompleteRequest tradingPhotoCard={data} />
      )}
    </div>
  );
};

export default TradeReviewRequestPage;
